import React, { useEffect } from "react";
import CreateDocForm from "../components/CreateDocForm";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

function CreateDocCenterPage() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:w-deflaut md:flex">
        <div className="w-full">
          <a href="/DocCenter" className="no-underline">
            <p className="text-header text-ft-light hover:text-ft font-bold">
              {t("documentCenterPage.newDocumentCenter")}
            </p>
          </a>
          <CreateDocForm
            campaign={location.state !== null ? location.state.event : ""}
          />
        </div>
      </div>
    </div>
  );
}

export default CreateDocCenterPage;
